<template>
  <div class="dashboardFooter">
    <div class="dashboardFooter-api">
      <button-com
        iconName="link"
        iconSize="large"
        iconColor="#888"
        tooltip=""
        class="bm-ghost bm-onlyIcon"
        @click.native="goTo('//api.lootbox.se/v1/feed/' + feedId)"
      ></button-com>
    </div>
    <usernav-com></usernav-com>
  </div>
</template>

<script>
import UsernavCom from '@/components/Usernav'

export default {
  props: ['feedId'],
  components: {
    UsernavCom
  },
  methods: {
    goTo (link) {
      const win = window.open(link, '_blank')
      win.focus()
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('dashboardFooter')
  position: fixed
  bottom: 0
  background: #FFF
  width: calc(100% - 285px)
  height: 70px
  line-height: 70px
  box-sizing: border-box
  padding: 0 15px 0 30px
  border-top: 1px solid rgba(0,0,0,.1)
  box-shadow: 0 -2px 4px rgba(0,0,0,.05)
  user-select: none

  +element('api')
    position: relative
    top: 15px

  span
    user-select: all

</style>



// WEBPACK FOOTER //
// src/components/DashboardFooter.vue